import React, { ReactElement, ReactNode } from 'react';

import { useListContext, useShowContextRequired } from 'ui-builder';
import { ProjectPermission, useAuthorizationChecker } from 'authorization-scope';
import { OpenFormIconButton, useProjectId } from 'features/nekst-widgets';
import { ProjectDetailFieldRow } from './types';
import EditFieldPopup, { FieldData } from './EditFieldPopup';

export default function EditableFieldCell(props: { children: ReactNode }): ReactElement {
  const showContext = useShowContextRequired<ProjectDetailFieldRow>();
  const listContext = useListContext<ProjectDetailFieldRow>();
  const { isGranted } = useAuthorizationChecker();
  const projectId = useProjectId();
  const field = showContext.data;

  const isEditable = isGranted(ProjectPermission.UPDATE_DETAILS) && !field.linkedTask;

  if (isEditable) {
    const afterSubmitFunc = async (data: FieldData) => {
      const newValue = data[`${field.setting.id}`];
      listContext._updateItems?.([{ ...field, value: newValue ?? undefined }]);
    };

    return (
      <div className="flex items-center gap-2">
        <div className="flex-1 min-w-0">{props.children}</div>
        <OpenFormIconButton
          form={
            <EditFieldPopup
              projectId={projectId}
              field={field}
              afterSubmitFunc={afterSubmitFunc}
            />
          }
          title={`Edit ${field.setting.name}`}
          className="opacity-0 group-hover:opacity-100 transition-opacity"
        />
      </div>
    );
  } else {
    return <div>{props.children}</div>;
  }
}
